import { useParams } from "react-router-dom";
import { ExtensionFolder } from "../Types";
import { useAppContext } from "../Contexts";

export function useEv2ExperimentParams(): {
  extensionName: string | undefined;
  experimentName: string | undefined;
  extensionFolder: ExtensionFolder | undefined;
  extensionParamName: string | undefined;
  extensionContextName: string | undefined;
} {
  const { extensionName: currentExtensionName, getNormalizedExtension } =
    useAppContext();

  const { extensionName: extensionParamName, experimentName } = useParams<{
    extensionName?: string;
    experimentName?: string;
  }>();

  const extensionName = extensionParamName || currentExtensionName;
  const extensionFolder = getNormalizedExtension(extensionName);
  const normalizedExtensionName = extensionFolder?.name || "";

  return {
    extensionName: normalizedExtensionName,
    experimentName,
    extensionParamName,
    extensionContextName: currentExtensionName,
    extensionFolder,
  };
}
